
export enum AttendeesFilter {
    All = "all",
    Confirmed = "confirmed",
    NotConfirmed = "notConfirmed"
}